import React, { useContext, useState } from 'react'
import { Card, CardHeader, CardBody, Input, Label } from 'reactstrap'
import { store, actions } from '../../stores/multipost'

export default function ScheduleSettings() {
  const { dispatch, scheduled, tz, share } = useContext(store)

  const tomorrow = new Date()
  tomorrow.setDate(tomorrow.getDate() + 1)

  const scheduledAt = share?.scheduled_at ? new Date(share.scheduled_at) : null

  const [scheduleDate, setScheduleDate] = useState(
    scheduledAt
      ? scheduledAt.toISOString().slice(0, 10)
      : tomorrow.toISOString().slice(0, 10)
  )

  const [scheduleTime, setScheduleTime] = useState(
    scheduledAt
      ? scheduledAt.toLocaleTimeString([], { hour12: false, hour: '2-digit', minute: '2-digit' })
      : '09:00'
  )

  const onScheduledChange = (e) => {
    dispatch({
      type: actions.SET_SCHEDULED,
      scheduled: e.target.checked
    })
  }


  return (
    <>
    <Card className={`rounded-2 ${!scheduled && 'mb-4'}`}>
      <CardHeader className={`rounded-top-2 p-0 ${!scheduled && 'border-bottom-0'}`}>
        <label htmlFor="post-schedule" className="px-3 py-2 m-0 d-flex align-items-center">
          <Input type="checkbox" className="m-0 me-2" id="post-schedule" checked={scheduled} onChange={onScheduledChange} />
          <span>Schedule post for later</span>
        </label>
      </CardHeader>
      {scheduled ? (
        <CardBody className="p-0 d-flex flex-row">
          <div className="form-floating flex-fill">
            <Input type="date" className="border-0 border-end" id="post-schedule-date" value={scheduleDate} onChange={e => setScheduleDate(e.target.value)} />
            <Label htmlFor="post-schedule-date">Date</Label>
          </div>
          <div className="form-floating flex-fill">
            <Input type="time" className="border-0" id="post-schedule-time" value={scheduleTime} onChange={e => setScheduleTime(e.target.value)} />
            <Label htmlFor="post-schedule-time">Time</Label>
          </div>
          <Input type="hidden" name="team_post[scheduled_at]" value={`${scheduleDate} ${scheduleTime}`} />
        </CardBody>
      ) : null}
    </Card>
    {scheduled ? (
        <span className="text-muted d-block mt-2 ms-1 mb-4">
          Date and time are in {tz}.&nbsp;
          <a href="/users/edit" target="_blank">Change your timezone in your profile</a>.
        </span>
      ) : null }
    </>
  )
}
